<template>
  <div class="big-data-top fix-box-between">
    <div class="top-l fix-box-align-center" @click='$router.push("/")' v-if='$route.path=="/bigData"'>
      <img src="/img/bigdata/change-icon.png" alt="" style='margin-right: 13px;'>
      返回至楼管家
    </div>
    <div class="top-l fix-box-align-center" @click='$router.push("/bigData")' v-else style='color: #B8D7FF;'>
      < 返回
    </div>
    <template v-if='$route.path=="/bigData"'>
      <div class='top-c1 fix-box-between' v-if='Width<1920'>
        <div class="compony">
          {{user.companyName}}
        </div>
        <img src="/img/bigdata/big-data-top-1366.png" alt="">
      </div>
      <div class='top-c' v-else>
        <div class='fix-box-between' style='height: 58px;'>
          <div class="compony">
            {{user.companyName}}
          </div>
          <div class="broadcast">
            <el-carousel direction="vertical" height='58px' indicator-position='none'  :autoplay='true'>
              <el-carousel-item class='broadcast-item fix-box-align-center' v-for="(item,index) in broadcast" :key='index' @click='tomessage'>
                <img src="/img/bigdata/broadcast-icon.png" alt="" style='margin-right: 10px;border: none'>
                <div class="broadcast-content ">
                  {{item.name}}
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="top-r fix-box-align-center" >
        <span @click='tomessage' class="fix-box-align-center" v-if='Width<1920&&broadcast.length' >
            <img src="/img/bigdata/broadcast-icon.png" alt="" style='margin-right: 5px;'>
        进入消息中心
        </span>

        <span @click='refresh' class="fix-box-align-center">
            <img src="/img/bigdata/refresh-icon.png" alt="" style='margin-right: 5px;margin-left: 20px;'>
          刷新
        </span>

      </div>
    </template>
    <template v-else>
      <div class="top-r fix-box-align-center" >
        <img src="/img/bigdata/big-data-top-1366.png" alt="" style='margin-right: 25px;'>
        <div class="broadcast" style='margin-right: 65px;'>
          <el-carousel height='58px' direction="vertical" indicator-position='none' :autoplay='true'>
            <el-carousel-item class='broadcast-item fix-box-align-center' v-for="(item,index) in broadcast" :key='index' @click='tomessage'>
              <img src="/img/bigdata/broadcast-icon.png" alt="" style='margin-right: 10px;border: none'>
              <div class="broadcast-content ">
                {{item.name}}
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <span @click='refresh' style='cursor: pointer;'>
            <img src="/img/bigdata/refresh-icon.png" alt="" style='margin-right: 5px;'>
        刷新
        </span>

      </div>
    </template>



  </div>
</template>

<script>
  import {auctionMessageList} from "../../../../api/bigData";
  import {mapState} from 'vuex'
  export default {
    name: "dataTop",
    props:['Width'],
    components: {},
    data() {
      return {
        broadcast:[],
      }
    },
    methods: {
      tomessage(){
        this.$router.push({path: '/messageCenter' })
      },
      refresh(){
        window.location.reload()
      },
      getList(){
        auctionMessageList({page:1,perPage:5}).then(res => {
          let data = res.data
          if (data.code === '000') {
            this.broadcast=data.content.list
            this.$emit('messageLength', this.broadcast.length||0)
          } else {

          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {

        })
      },
    },
    created() {
      this.getList()
    },
    computed: {
      ...mapState({
        user:state=>state.user.user
      })
    },
  }
</script>

<style scoped lang="scss">
  .broadcast{
    width: 469px;
    height: 58px;
    margin-right: 30px;
    .broadcast-item{
      color: #B8D7FF;
      line-height: 58px;
      font-size: 16px;
      display: flex!important;
      cursor: pointer;
      .broadcast-content{
        width: 435px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .big-data-top{
    max-width: 1920px;
    margin: 0 auto;
    .top-l{
      color: #4F85FF;
      font-size: 16px;
      cursor: pointer;
    }
    .top-r{
      color: #B8D7FF;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .top-c{
    width: 1367px;
    height: 67px;
    background: url("/img/bigdata/big-data-top-1920.png") no-repeat;
    .compony{
      width: 371px;
      text-align: center;
      color: #B8D7FF;
      font-size: 16px;
      font-family:PingFangSC-Semibold,PingFang SC;
    }

  }
  .top-c1{
    .compony{
      text-align: center;
      color: #B8D7FF;
      font-size: 16px;
      font-family:PingFangSC-Semibold,PingFang SC;
      margin-right: 102px;
    }
  }
</style>
